const genders = {
    f: new Set([
        'анастасия',
        'анна',
        'екатерина',
        'мария',
        'дарья',
        'александра',
        'елизавета',
        'юлия',
        'полина',
        'ольга',
        'виктория',
        'елена',
        'татьяна',
        'ирина',
        'ксения',
        'наталья',
        'валерия',
        'светлана',
        'алена',
        'алина',
        'марина',
        'кристина',
        'евгения',
        'софья',
        'диана',
        'маргарита',
        'надежда',
        'яна',
        'наталия',
        'вероника',
        'арина',
        'любовь',
        'вера',
        'варвара',
        'софия',
        'карина',
        'ангелина',
        'алиса',
        'валентина',
        'нина',
        'людмила',
        'галина',
        'оксана',
        'олеся',
        'настя',
        'ульяна',
        'лилия',
        'таисия',
        'антонина',
        'василиса',
        'лидия',
        'тамара',
        'милена',
        'элина',
        'влада',
        'эльвира',
        'владислава',
        'алла',
        'анжелика',
        'кира',
        'регина',
        'лилит',
        'сабина',
        'динара',
        'инна',
        'лада',
        'лариса',
        'серафима',
        'ярослава',
        'альбина',
        'дария',
        'дина',
        'камила',
        'лиза',
        'майя',
        'аида',
        'зоя',
        'камилла',
        'катерина',
        'лейла',
        'таня',
        'юлиана',
        'алевтина',
        'анжела',
        'виолетта',
        'виталия',
        'дана',
        'дания',
        'ева',
        'жанна',
        'зинаида',
        'мариам',
        'соня',
        'ася',
        'зарина',
        'илона',
        'инесса',
        'лия',
        'луиза',
        'мадина',
        'милана',
        'фаина',
        'эльмира',
        'эмилия',
        'белла',
        'дарина',
        'джамиля',
        'евдокия',
        'лиана',
        'марта',
        'наира',
        'рената',
        'сюзанна',
        'элеонора',
        'аглая',
        'аделина',
        'айсель',
        'алеся',
        'амина',
        'анита',
        'дайана',
        'даяна',
        'злата',
        'изабель',
        'лаура',
        'лина',
        'марфа',
        'марья',
        'марьям',
        'наиль',
        'нармин',
        'настасья',
        'нелли',
        'розалия',
        'снежана',
        'стелла',
        'эвелина',
        'элла',
        'эллина',
    ]),
    m: new Set([
        'александр',
        'дмитрий',
        'никита',
        'андрей',
        'иван',
        'алексей',
        'сергей',
        'михаил',
        'максим',
        'артем',
        'илья',
        'антон',
        'павел',
        'даниил',
        'кирилл',
        'владимир',
        'владислав',
        'денис',
        'евгений',
        'егор',
        'николай',
        'георгий',
        'роман',
        'игорь',
        'константин',
        'олег',
        'григорий',
        'василий',
        'виктор',
        'глеб',
        'федор',
        'юрий',
        'вадим',
        'петр',
        'данила',
        'станислав',
        'вячеслав',
        'виталий',
        'ярослав',
        'арсений',
        'руслан',
        'степан',
        'тимур',
        'артур',
        'борис',
        'тимофей',
        'валерий',
        'леонид',
        'матвей',
        'артемий',
        'всеволод',
        'филипп',
        'давид',
        'лев',
        'семен',
        'марк',
        'анатолий',
        'валентин',
        'герман',
        'святослав',
        'богдан',
        'влад',
        'шамиль',
        'марат',
        'рустам',
        'эмиль',
        'яков',
        'эльдар',
        'аркадий',
        'ростислав',
        'рамиль',
        'эдуард',
        'геннадий',
        'карен',
        'макар',
        'ринат',
        'савелий',
        'альберт',
        'арман',
        'клим',
        'ян',
        'дамир',
        'даниэль',
        'ибрагим',
        'ильяс',
        'иннокентий',
        'магомед',
        'мурад',
        'нарек',
        'родион',
        'серафим',
        'станислава',
        'азамат',
        'айдар',
        'арам',
        'армен',
        'вениамин',
        'захар',
        'игнат',
        'ильдар',
        'рафаэль',
        'роберт',
        'рома',
        'саид',
        'слава',
        'стас',
        'тихон',
        'эдгар',
        'эрнест',
        'аким',
        'алим',
        'ашот',
        'генрих',
        'ефим',
        'иоанн',
        'ислам',
        'карим',
        'левон',
        'леон',
        'назар',
        'рауф',
        'руфат',
        'савва',
        'тарас',
        'тарон',
        'тигран',
        'феликс',
    ]),
};

export default function getGender(name = '') {
    let names = name
        .split(' ')
        .reverse()
        .map(name => name.toLowerCase().replace(/ё/g, 'е'));

    const genderedName = names.find(name => genders.m.has(name) || genders.f.has(name));

    if (genderedName) {
        return genders.m.has(genderedName) ? 'm' : 'f';
    }

    return '';
}



// WEBPACK FOOTER //
// ./src/utils/getGender.js